import { ref as databaseRef, get, set, query, orderByChild, equalTo } from "firebase/database";
import { database } from "../../FirebaseConfig";

export const UserKeysService = {
  // Créer la même fonction de conversion de nom
  createKeyFromName(name) {
    return name
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]/g, '_');
  },

  // Sauvegarder les clés d'un utilisateur
  async saveUserKeys(userId, aggregatorName, keys) {
    try {
      const aggregatorKey = this.createKeyFromName(aggregatorName);
      
      // Vérifier si l'agrégateur existe
      const aggregatorRef = databaseRef(database, `aggregators/${aggregatorKey}`);
      const aggregatorSnapshot = await get(aggregatorRef);

      if (!aggregatorSnapshot.exists()) {
        throw new Error("Agrégateur non trouvé");
      }

      // Sauvegarder les clés
      const userKeyRef = databaseRef(
        database,
        `userAggregatorKeys/${userId}/${aggregatorKey}`
      );

      await set(userKeyRef, {
        keys: keys,
        isActive: true,
        updatedAt: Date.now()
      });

      return true;
    } catch (error) {
      console.error('Erreur:', error);
      throw error;
    }
  },

  // Récupérer les clés d'un utilisateur
  async getUserKeys(userId, aggregatorName) {
    const aggregatorKey = this.createKeyFromName(aggregatorName);
    const keyRef = databaseRef(
      database, 
      `userAggregatorKeys/${userId}/${aggregatorKey}`
    );
    
    const snapshot = await get(keyRef);
    return snapshot.val();
  },

  // Récupérer tous les agrégateurs actifs d'un utilisateur
  async getUserActiveAggregators(userId) {
    try {
      const userKeysRef = databaseRef(database, `userAggregatorKeys/${userId}`);
      const snapshot = await get(userKeysRef);
      
      if (!snapshot.exists()) {
        return [];
      }

      const activeAggregators = [];
      const userKeys = snapshot.val();

      for (const [aggregatorKey, keyData] of Object.entries(userKeys)) {
        if (keyData.isActive) {
          const aggregatorRef = databaseRef(database, `aggregators/${aggregatorKey}`);
          const aggregatorSnapshot = await get(aggregatorRef);
          
          if (aggregatorSnapshot.exists()) {
            activeAggregators.push({
              key: aggregatorKey,
              ...aggregatorSnapshot.val(),
              userKeys: keyData.keys
            });
          }
        }
      }

      return activeAggregators;
    } catch (error) {
      console.error('Erreur:', error);
      return [];
    }
  }
};